import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-6 space-y-4" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium mt-auto" }, "Kommuner overblik", -1)
const _hoisted_4 = { class: "space-y-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-semibold" }, "Bagatelgrænse", -1)
const _hoisted_6 = { class: "bg-white rounded-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_GenericTable = _resolveComponent("GenericTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_CustomSelect, {
          value: _ctx.selectedTrivialLimit,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTrivialLimit) = $event)),
          label: "Bagatelgrænse",
          items: _ctx.trivialLimits,
          "item-text": "text",
          "item-value": "value",
          class: "w-32"
        }, null, 8, ["value", "items"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_GenericTable, {
        headers: _ctx.headers,
        items: _ctx.items,
        "pinned-bottom-row-data": _ctx.pinnedBottomRowData
      }, null, 8, ["headers", "items", "pinned-bottom-row-data"])
    ])
  ]))
}